<div class="db-modes-list__mode-list" xmlns="http://www.w3.org/1999/html">
  <div #selectDropdownToggle >
    <div class="ds-input db-modes-list__mode-dropdown" [ngClass]="{'disabled': loading || !paidClient}"
         [dsTooltip]="actionRef" [dsTooltipMode]="'hoverStatic'"
         dsTooltipPosition="bottom" dsTooltipAlign="left" [dsTooltipVisible]="!paidClient">
      <p>{{modeTitle ?  (modeTitle | dbText) : 'text_selectMode' | dbText}}</p>
      <i class="db-icon db-icon-ds-arrow-small" [ngClass]="{'db-icon-arrow-up': toggled && paidClient}"></i>
    </div>
  </div>

  <ng-template #actionRef>
    <div class="db-modes-list__upgrade-tooltip">Custom optimization levels are<br/> available on 10Web Booster Pro.<br/> <a (click)="sendEvent()" [routerLink]="['/upgrade-plan']">{{showPercentOffer ? 'upgrade' : ('text_tryForFree' | dbText)}}</a></div>
  </ng-template>

  <div #selectDropdown class="db-modes-list__dropdown-list"
       [ngClass]="{'toggled': toggled && paidClient}">
    <div dbCustomScrollbar>
      <ul>
        <li class="db-modes-list__mode-item" *ngFor="let option of modesList; let i = index" (click)="pageMode !== option?.value && selectMode(option.value)"
          [ngClass]="{'selected': pageMode === option?.value}">
          <i class="db-icon db-icon-circle-sm {{option?.value}}"></i>
          <div>
            <p class="ds-dropdown-option-label" [ngClass]="{'ds-dropdown-option-label-bold': option?.description}" [innerHTML]="option?.label | dbText "></p>
            <p *ngIf="option?.description" class="ds-dropdown-option-desc" [innerHTML]="option?.description | dbText "></p>
            <div class="ds-dropdown__default" *ngIf="defaultModeLevel === option?.value">{{ 'text_default' | dbText }}</div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
